<!--成品不良率报表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          v-decorator="['organizationCode']"
          :allow-clear="false"
          :default-active-first-option="defaultSelect"
          slot="organizationCode"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.organizationCode"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <a-range-picker
          slot="createTime"
          v-model="currentCreateTimeObj"
          @change="changePriceRangeDate"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiFinishedProductDefectRateReportListExport" ref="download" />
        <a-button type="primary" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
        >
          <!-- 一次不良率 -->
          <template slot="firstDefectRate" slot-scope="{ text }">
            {{ (text * 100).toFixed(2) }}%
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiFinishedProductDefectRateReportList, apiFinishedProductDefectRateReportListExport } from '@/api/report/finished-product-verification.js'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import moment from 'moment'
import cacheSearch from '@/mixins/cacheSearch'

export default {
  // eslint-disable-next-line
  name: 'Finished-product-defect-rate', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  mixins: [cacheSearch],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      currentCreateTimeObj: [],
      apiFinishedProductDefectRateReportListExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiFinishedProductDefectRateReportList, true),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        createTime: undefined,
        itemName: undefined,
        staCreateTime: undefined,
        endCreateTime: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '工厂', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '起止日期', decorator: ['createTime'], type: 'createTime' },
        { label: '型号(物料名称)', decorator: ['itemName'], type: 'input' }
      ],
      // 表格字段
      columns: [
        { title: '日期', dataIndex: 'createDate', align: 'center', width: 150, ellipsis: true },
        { title: '工厂', dataIndex: 'organizationName', align: 'center', width: 150, ellipsis: true },
        { title: '型号(物料名称)', dataIndex: 'itemName', align: 'center', width: 150, ellipsis: true },
        { title: '订单数', dataIndex: 'planQuantity', align: 'center', width: 150, ellipsis: true },
        { title: '检验数', dataIndex: 'inspectQty', align: 'center', width: 150, ellipsis: true },
        { title: '一次不良数', dataIndex: 'firstDefectSum', align: 'center', width: 150, ellipsis: true },
        { title: '一次不良率', dataIndex: 'firstDefectRate', scopedSlots: { customRender: 'firstDefectRate' }, align: 'center', width: 200, ellipsis: true }
      ]
    }
  },
  created () {
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      // 处理缓存逻辑
      this.getHistoryCache(
        'refSearchForm',
        'organizationCode',
        {
          currentCreateTimeObj: ['staCreateTime', 'endCreateTime']
        },
        false
      )
    } else {
      this.queryParams.staCreateTime = moment().subtract(30, 'days').format('YYYY-MM-DD 00:00:00')
      this.queryParams.endCreateTime = moment().format('YYYY-MM-DD 23:59:59')
      this.currentCreateTimeObj = [moment().subtract(30, 'days'), moment()]
    }
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 选择时间
    changePriceRangeDate (dateArr, dateStrArr) {
      if (dateStrArr?.length > 0 && dateStrArr[0]) {
        this.queryParams.staCreateTime = dateStrArr[0] + ' 00:00:00'
        this.queryParams.endCreateTime = dateStrArr[1] + ' 23:59:59'
      } else {
        this.queryParams.staCreateTime = undefined
        this.queryParams.endCreateTime = undefined
      }
    },
    // 表单搜索
    onSearch (value = {}) {
      const params = {
        ...this.queryParams,
        ...value
      }
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        organizationCode: undefined,
        createTime: undefined,
        itemName: undefined,
        staCreateTime: undefined,
        endCreateTime: undefined
      }
      this.currentCreateTimeObj = [];
    },
    // 导出
    handleExport () {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
